import React, { useState } from "react";
import ssoImg1 from "./../../../../assets/images/atn.png"; // Adjust the path as necessary
import pilotIcon from "./../../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function SeaWatchReponseAidsToNavigationTab() {
    const cardData = [
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Erection or placing of any fixed, floating and electronic AtoN, mark or beacon",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Removal or discontinuation of any fixed, floating and electronic AtoN, mark or beacon",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Altering an AtoN (colour, character, height, range, etc.), or the mode  of exhibiting lights of any fixed, floating and electronic AtoN, mark or beacon in any lighthouse, buoy or beacon.",
  },
  

  
  
  

  
];



  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SEA WATCH & RESPONSE
        <span className="text-orange-ef3e33 font-400"> AIDS TO NAVIGATION </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          
          <p className="mb-3 text-primary-color">The Navigation section is to ensure the safety of navigation in South  African waters through enhancing our MDA and regulation to ensure  compliance with international conventions and agreements.</p>

          <p className="mb-3 text-primary-color">It covers the regulation of Aids to  Navigation (AtoN) coastal and inland waterways, including Vessel Traffic Services (VTS), terrestrial and satellite Automatic Identification  System (AIS), eNavigation (eNAV), Long range Identification and Tracking (LRIT) and oversight of Hydrography.</p>

          <p className="font-18 font-900 mb-3">Aids to Navigation (AtoN)</p>

          <p className="mb-3 text-primary-color">The Aids to Navigation section  contributes towards SAMSA and South Africa meeting its obligations in  terms of ensuring safety of life and property at sea through the  standardisation, harmonisation and compliance of all Aids to Navigation  (AtoN), both at sea and on navigable inland waterways of South Africa,  by:</p>

          <ul className="green-star-ul">
            <li>Ensuring that as it deems  practical and necessary, for appropriate AtoN to be provided as the  volume of traffic and the degree of risks requires</li>
            <li>Ensuring all AtoN, fixed and floating, meeting the requirements of present and changing needs of all mariners</li>
            <li>Obtaining uniformity of all AtoN  by taking into account appropriate international directives,  requirements, recommendations and guidelines</li>
            <li>Ensuring all AtoN meet acceptable standards</li>
            <li>Providing technical consultancy and advice on AtoN</li>
            <li>Authorising the:</li>
          </ul>

          <div className="row g-4">
           {cardData.map((card, index) => (
              <div className="col-md-12 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0">
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>


        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        <div className="col-12">

          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  Any request to deploy, alter or remove AtoN, or any other communiqué regarding AtoN can be sent to   below;
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <p className=""><b className="d-block">Service Area</b></p>

                      <p className="">MRCC OPS (24/7 Service)<br/>
                        Phone : +27(0)21 938 3300<br/>
                        Fax: +27(0)21 938 3309<br/>
                        E-mail:  <a href="mailto:mrcc.ct@samsa.org.za">mrcc.ct@samsa.org.za</a> </p>
                      
                    </div>

                    <div className="col-md-6">
                      <p className=""><b className="d-block">Service Area</b></p>

                      <p className="">​CSWR Admin  (08:00 – 16:30) (Monday - Friday)​<br/>

                        Phone : +27(0)21 938 3300<br/>
                        Fax: +27(0)21 938 3319<br/>
                        E-mail:  <a href="mailto:aton@samsa.org.za">aton@samsa.org.za</a> </p>
                      
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          
           
          </div>
        </div>
        

      
      </div>
    </>
  );
}

export default SeaWatchReponseAidsToNavigationTab;